import React from 'react';

import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Link,
  Flex,
  Divider,
} from '@chakra-ui/react';

import { IAuth } from '../../../Auth';
import { useGetLiveLoginLink } from '../../../hooks/useGetLiveLoginLink';
import { CloseIcon, FanaticsCollectLogo } from '../../../Icons';
import { ExternalLinkIcon } from '../../../Icons/ExternalLinkIcon';
import { useModalContext } from '../../../ModalProvider';
import { EColor } from '../../../Theme';
import { getLink, getMonolithUrls } from '../../utils';

interface INewMobileNavModalProps {
  auth?: IAuth;
  hasUnpaidInvoices: boolean;
  show: boolean;
  closeMenu: () => void;
  trackAndClose: (sectionClicked: string) => void;
}

export const NewMobileNavModal = ({
  auth,
  hasUnpaidInvoices,
  show,
  closeMenu,
  trackAndClose,
}: INewMobileNavModalProps) => {
  const { fanaticsCollectBaseUrl } = useModalContext();
  const { submissionUrl } = getMonolithUrls(fanaticsCollectBaseUrl);
  const fanaticsLiveUrl = useGetLiveLoginLink();
  const { profile } = auth || {};

  return (
    <Modal isOpen={show} motionPreset="slideInLeft" onClose={closeMenu}>
      <ModalOverlay />
      <ModalContent
        alignItems="start"
        background={EColor.White}
        borderRadius="0"
        containerProps={{ justifyContent: 'start' }}
        display="flex"
        flexDirection="column"
        marginY="0"
        maxWidth={{ base: '100%', md: '380px' }}
        minHeight="100vh"
        padding="16px"
        width="100%"
      >
        <ModalCloseButton
          alignItems="center"
          gap="8px"
          mb="16px"
          mt="16px"
          position="static"
          w="fit-content"
        >
          <CloseIcon boxSize="24px" />
          <FanaticsCollectLogo height="22px" width="154px" />
        </ModalCloseButton>
        <ModalBody
          display="flex"
          flex="1"
          flexDirection="column"
          justifyContent="space-between"
          p="0"
          pb="24px"
          width="100%"
        >
          <Flex flex="1" flexDirection="column" px="4px">
            <Link
              _active={{ color: EColor.Black }}
              _hover={{ color: EColor.Black, textDecoration: 'none' }}
              alignItems="center"
              display="flex"
              fontSize="16px"
              fontWeight="700"
              gap="8px"
              href={getLink(fanaticsCollectBaseUrl, 'fixedSRP')}
              justifyContent="start"
              py="12px"
              onClick={() => trackAndClose('Buy Now')}
            >
              Buy Now
            </Link>

            <Link
              _active={{ color: EColor.Black }}
              _hover={{ color: EColor.Black, textDecoration: 'none' }}
              alignItems="center"
              display="flex"
              fontSize="16px"
              fontWeight="700"
              gap="8px"
              href={getLink(fanaticsCollectBaseUrl, 'weeklySRP')}
              justifyContent="start"
              py="12px"
              onClick={() => trackAndClose('Marketplace')}
            >
              Auction
            </Link>

            <Link
              _active={{ color: EColor.Black }}
              _hover={{ color: EColor.Black, textDecoration: 'none' }}
              alignItems="center"
              display="flex"
              fontSize="16px"
              fontWeight="700"
              gap="8px"
              href={getLink(fanaticsCollectBaseUrl, 'premierSRP')}
              justifyContent="start"
              py="12px"
              onClick={() => trackAndClose('Premier Auction')}
            >
              Premier Auction
            </Link>
            <Link
              _active={{ color: EColor.Black }}
              _hover={{ color: EColor.Black, textDecoration: 'none' }}
              alignItems="center"
              display="flex"
              fontSize="16px"
              fontWeight="700"
              gap="8px"
              href={fanaticsLiveUrl}
              justifyContent="start"
              py="12px"
              target="_blank"
              onClick={() => trackAndClose('Live Breaking')}
            >
              Live Breaking
              <ExternalLinkIcon
                boxSize="16px"
                color={EColor.Black}
                ml="2px"
                transform="translateY(-2px)"
              />
            </Link>
            <Divider
              backgroundColor={EColor.Neutral150}
              height="1px"
              mb="16px"
              mt="16px"
              width="100%"
            />
            <Link
              _active={{ color: EColor.Black }}
              _hover={{ color: EColor.Black, textDecoration: 'none' }}
              alignItems="center"
              display="flex"
              fontSize="16px"
              fontWeight="700"
              gap="8px"
              href={submissionUrl}
              justifyContent="start"
              py="12px"
              onClick={() => trackAndClose('Ship to Vault')}
            >
              Submit items to Vault
            </Link>
          </Flex>

          <Flex flexDirection="column" gap="20px" py="12px">
            {profile?.isAdmin && (
              <>
                <Divider
                  backgroundColor={EColor.Neutral150}
                  height="1px"
                  mb="16px"
                  width="100%"
                />
                <Link
                  _active={{ color: EColor.Black }}
                  _hover={{ color: EColor.Black, textDecoration: 'none' }}
                  alignItems="center"
                  display="flex"
                  fontSize="16px"
                  fontWeight="700"
                  gap="8px"
                  href={getLink(fanaticsCollectBaseUrl, 'adminHome')}
                  justifyContent="start"
                  py="12px"
                >
                  Admin
                </Link>
              </>
            )}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
